// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35sRz","fullView":"styles_fullView__t8R_s"};